// extracted by mini-css-extract-plugin
export default {"deviceButton":"RecordingButton_deviceButton__VTZ6M","icon":"RecordingButton_icon__RbX0s"};